export default __webpack_public_path__ + "static/1-cyberpunk-8f4b283f2c4904ecedd77b6ba0079d93.png";